"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
  _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
  _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
  _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
  _react = _interopRequireWildcard(require("react")),
  _InputLabel = _interopRequireDefault(require("../FormElements/InputLabel")),
  _excluded = ["field", "value", "validationMessage", "touched", "setTouched", "hideField", "updateForm", "styledComponents", "error", "unsetError"];
function _getRequireWildcardCache(a) {
  if ("function" != typeof WeakMap) return null;
  var b = new WeakMap(),
    c = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(a) {
    return a ? c : b;
  })(a);
}
function _interopRequireWildcard(b, c) {
  if (!c && b && b.__esModule) return b;
  if (null === b || "object" != _typeof(b) && "function" != typeof b) return {
    default: b
  };
  var d = _getRequireWildcardCache(c);
  if (d && d.has(b)) return d.get(b);
  var e = {
      __proto__: null
    },
    f = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in b) if ("default" != a && Object.prototype.hasOwnProperty.call(b, a)) {
    var g = f ? Object.getOwnPropertyDescriptor(b, a) : null;
    g && (g.get || g.set) ? Object.defineProperty(e, a, g) : e[a] = b[a];
  }
  return e["default"] = b, d && d.set(b, e), e;
}
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    (0, _defineProperty2["default"])(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
var _default = exports["default"] = function (a) {
  var b = a.field,
    c = a.value,
    d = a.validationMessage,
    e = a.touched,
    f = a.setTouched,
    g = a.hideField,
    h = a.updateForm,
    i = a.styledComponents,
    j = a.error,
    k = a.unsetError,
    l = (0, _objectWithoutProperties2["default"])(a, _excluded),
    m = b.id,
    n = b.formId,
    o = b.type,
    p = b.label,
    q = b.placeholder,
    r = b.isRequired,
    s = b.maxLength,
    t = b.description,
    u = b.descriptionPlacement,
    v = b.labelPlacement,
    w = b.width,
    x = b.customName,
    y = b.inputs,
    z = b.cssClass,
    A = b.passwordStrengthEnabled,
    B = b.minPasswordStrength,
    C = i || !1,
    D = C.Input,
    E = void 0 === D ? "input" : D,
    F = C.Label,
    G = void 0 === F ? "label" : F,
    H = C.Box,
    I = void 0 === H ? "div" : H,
    J = (0, _react.useState)(y),
    K = (0, _slicedToArray2["default"])(J, 2),
    L = K[0],
    M = K[1],
    N = (0, _react.useState)("blank"),
    O = (0, _slicedToArray2["default"])(N, 2),
    P = O[0],
    Q = O[1],
    R = function R(a, b) {
      var c = _objectSpread({}, L);
      c[b].cssClass = a ? "filled" : "", M(c);
    },
    S = function S(a) {
      var e,
        f,
        b = Math.LN2,
        c = Math.log,
        d = Math.pow,
        g = 0;
      return 0 >= a.length ? "blank" : 4 > a.length ? "short" : (a.match(/[0-9]/) && (g += 10), a.match(/[a-z]/) && (g += 26), a.match(/[A-Z]/) && (g += 26), a.match(/[^a-zA-Z0-9]/) && (g += 31), e = c(d(g, a.length)), f = e / b, 40 > f ? "bad" : 56 > f ? "good" : "strong");
    },
    T = function T(a) {
      var b = S(a);
      Q(b);
    };
  return _react["default"].createElement(I, {
    width: w,
    className: d && e || j ? "form-field error ".concat(z) : "form-field ".concat(z),
    style: {
      display: g ? "none" : void 0
    }
  }, _react["default"].createElement("div", {
    className: o
  }, _react["default"].createElement(_InputLabel["default"], {
    formId: n,
    id: m,
    label: p,
    labelPlacement: v,
    isRequired: r,
    styledComponent: i
  }), "above" === u && t && _react["default"].createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: t.replace(/\n/g, "<br />")
    }
  }), _react["default"].createElement("div", {
    className: "ginput_container ginput_container_password"
  }, y && y.length && y.map(function (a, g) {
    return !a.isHidden && _react["default"].createElement("span", {
      key: "input_".concat(n, "_").concat(a.id),
      className: "".concat(1 < y.length ? "ginput_".concat(0 === g ? "left" : "right") : "medim", " ").concat(L[g].cssClass ? L[g].cssClass : "")
    }, _react["default"].createElement(E, {
      id: "input_".concat(n, "_").concat(a.id, "_").concat(g),
      name: x || "input_".concat(m).concat(1 === g ? "_".concat(g + 1) : ""),
      type: o,
      value: c && c[g] && c[g].val ? c[g].val : "",
      placeholder: a.placeholder ? a.placeholder : q,
      required: r,
      autoComplete: "off",
      onChange: function onChange(a) {
        b.subId = g, h(a, b), k(m), A && 0 === g && T(a.target.value);
      },
      onBlur: function onBlur(a) {
        b.subId = g, h(a, b), f(m), R(c && c[g] && c[g].val && "" !== c[g].val, g);
      },
      onFocus: function onFocus() {
        return R(!0, g);
      },
      "aria-label": p,
      "aria-describedby": "error_".concat(n, "_").concat(a.id, "_").concat(g),
      "aria-invalid": !!d && e
    }), _react["default"].createElement("label", {
      htmlFor: "input_".concat(n, "_").concat(a.id, "_").concat(g)
    }, a.placeholder || a.label));
  })), (d && e || j) && _react["default"].createElement("span", {
    className: "error-message",
    id: "error_".concat(n, "_").concat(m),
    dangerouslySetInnerHTML: {
      __html: d || j
    }
  }), "above" !== u && t && _react["default"].createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: t.replace(/\n/g, "<br />")
    }
  }), !(d && e || j) && A && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    id: "input_".concat(n, "_").concat(m, "_strength_indicator"),
    className: "gfield_password_strength ".concat(P)
  }, P && "blank" !== P ? P : "Strength indicator"), _react["default"].createElement("input", {
    type: "hidden",
    className: "gform_hidden",
    id: "input_".concat(n, "_").concat(m, "_strength"),
    name: "input_".concat(m, "_strength"),
    value: P
  }))));
};